import React from 'react';

function LogoBrandingSolutions({ setView }) {
  const handleNav = (e, path, view) => {
    e.preventDefault();
    if (setView) {
      if (window.location.pathname !== path) {
        window.history.pushState({}, '', path);
      }
      setView(view);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.location.href = path;
    }
  };

  const solutions = [
    {
      number: '01',
      title: 'Brand Identity',
      text: (
        <>
          A company logo design is the main element of your web identity, and it builds the first impression before your audience. A logo is not just an image on your digital platforms; it represents your brand and conveys your vision to the world. An illustrative logo design is the first thing a viewer notices about your brand; it serves as a unique identity that captures attention and engages your audience.
        </>
      ),
      icon: (
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="rgba(255, 255, 255, 0.85)" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
          <rect x="4" y="2" width="16" height="20" rx="3" />
          <circle cx="11" cy="11" r="3" />
          <path d="m14 14 3 3" />
        </svg>
      )
    },
    {
      number: '02',
      title: 'Professional Logo Design',
      text: (
        <>
          A good 3d logo design is very important for the company, and you must pay attention to the brand logo design process to grow your returns. If you have a good design, you will have a good conversion rate. And good conversion rates bring good revenue for you. We have a complete plan to create a professional logo design, whether it is a 3D or 2D logo designs that help your brand engage faster.
        </>
      ),
      icon: (
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="rgba(255, 255, 255, 0.85)" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
          <path d="m18 2 4 4-12 12H6v-4L18 2z" />
          <path d="m14.5 5.5 4 4" />
          <path d="m2 18 4 4" />
          <path d="m6 14-4 4" />
          <path d="m10 18-4 4" />
        </svg>
      )
    },
    {
      number: '03',
      title: 'Logo Redesign and Visual Update',
      text: (
        <>
          You can add a modern touch to your old and unattractive logo with our graphic design logo. A professionally designed modern logo works best for{' '}
          <a
            href="/web-design/"
            onClick={(e) => handleNav(e, '/web-design/', 'web-design')}
            className="text-red"
          >
            web design
          </a>
          ,{' '}
          <a
            href="/social-media-marketing/"
            onClick={(e) => handleNav(e, '/social-media-marketing/', 'social-media-marketing')}
            className="text-red"
          >
            social media marketing
          </a>
          , and{' '}
          <a
            href="/seo-services/"
            onClick={(e) => handleNav(e, '/seo-services/', 'seo-services')}
            className="text-red"
          >
            search engine optimization
          </a>
          . Every marketing needs a fresh feel that can resonate with the present-day audience. We are here for you to provide you with a new logo that tells your old story but with a today feel.
        </>
      ),
      icon: (
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="rgba(255, 255, 255, 0.85)" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z" />
          <polyline points="9 13 11.5 15.5 15.5 11.5" />
        </svg>
      )
    },
    {
      number: '04',
      title: 'Dedicated Logo Design Unit',
      text: (
        <>
          Our{' '}
          <a
            href="/ecommerce-web-development/"
            onClick={(e) => handleNav(e, '/ecommerce-web-development/', 'ecommerce-web-development')}
            className="text-red"
          >
            E-commerce website development
          </a>{' '}
          and logo design company has a complete workforce of in-house designers. They are skillful and expert at their design job. Our team maintains complete transparency with the clients at every step of the process. The suggestions and feedback of our clients are valuable to us; that is the reason we give our best to design a logo as per their needs and expectations.
        </>
      ),
      icon: (
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="rgba(255, 255, 255, 0.85)" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" />
          <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" />
          <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" />
          <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
        </svg>
      )
    },
    {
      number: '05',
      title: 'Brand Consistency Across Channels',
      text: (
        <>
          We make sure to provide you with a logo design that is functional across different channels. Our designs are best for print as well as digital platforms. Being Experts, we deliver clear and productive designs that can convey your brand message and increase your brand awareness everywhere, regardless of medium or channel.
        </>
      ),
      icon: (
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="rgba(255, 255, 255, 0.85)" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z" />
          <polyline points="9 13 11.5 15.5 15.5 11.5" />
        </svg>
      )
    }
  ];

  return (
    <section className="logo-solutions-section">
      <div className="container">
        {/* Section Header */}
        <div className="logo-solutions-header">
          <h2 className="logo-solutions-title">
            Complete <span className="text-red">Logo Design &amp; Branding</span> Solutions
          </h2>
          <p className="logo-solutions-subtitle">
            Attractive Logo Design That Tells Your Brand’s Story
          </p>
        </div>

        {/* 2-Column Grid */}
        <div className="logo-solutions-grid">
          {solutions.map((item, index) => (
            <div 
              key={index} 
              className={`logo-solution-card ${index === 4 ? 'card-spanning' : ''}`}
            >
              <div className="logo-solution-card-top">
                <span className="logo-solution-num">{item.number}</span>
                <div className="logo-solution-icon">
                  {item.icon}
                </div>
              </div>

              <h3 className="logo-solution-card-title">{item.title}</h3>

              <p className="logo-solution-card-text">
                {item.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default LogoBrandingSolutions;
